// extracted by mini-css-extract-plugin
export default {"nameLink":"nameCell_nameLink__hxuI3"};